import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-news',
  templateUrl: './news.component.svg',
})
export class NewsComponent extends MedrecordIcon {
  viewHeight = 24;
  viewWidth = 24;
}
